import * as React from 'react';
import { SVGProps } from 'react';

const IconLeafSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M19.142 4.853c-2.852 2.376-6.968 6.652-11.086 10.93C5.984 17.937 3.912 20.089 2 22l2 2c.816-1.36 1.92-2.837 3.172-4.337 2.626.633 7.039 1.122 9.828-1.667C21.998 12.998 21.998 2 21.998 2S10.996 2 6 6.996c-2.747 2.747-2.314 7.07-1.695 9.708 8.204-8.028 14.837-11.85 14.837-11.85z" />
  </svg>
);
export default IconLeafSizeM;
